/**
 * 列表页「详情返回保持分页」全局 mixin
 *
 * 通过 main.js 里 Vue.mixin 全局注册，所有组件自动获得以下逻辑（未声明
 * keepPageField 的组件会直接跳过「暂存/恢复」，但仍参与「清除」）。
 *
 * 行为：
 *   - 列表页进入详情页（同域且目标不在左侧菜单）时，暂存 { path, page }。
 *   - 离开任意页面时，若导航目标不是「暂存的目标列表」，则清除暂存，
 *     避免「列表→详情→分类→列表」时暂存残留导致误恢复。
 *   - 列表页进入时，若暂存 path 与当前路由一致则恢复页数，并「用后即焚」。
 *
 * 列表页用法（仅需在 data 中声明一个字段）：
 *   keepPageField: "queryInfo.page"   // 分页字段路径
 */
import { isInLeftMenu } from "@/js/menu";

// 统一暂存 key
const CACHE_KEY = "mk_list_page_cache";

// 按点号路径读取对象属性
function getPath(obj, path) {
  return path.split(".").reduce((cur, key) => (cur == null ? cur : cur[key]), obj);
}

// 按点号路径写入对象属性（末段之前的所有层级需已存在）
function setPath(obj, path, value) {
  const keys = path.split(".");
  let cur = obj;
  for (let i = 0; i < keys.length - 1; i++) {
    cur = cur[keys[i]];
  }
  cur[keys[keys.length - 1]] = value;
}

// 详情页与列表页同域（/menu 后第一段相同）；跨域切换不算详情页
function sameDomain(a, b) {
  return (a || "").split("/")[2] === (b || "").split("/")[2];
}

export default {
  beforeRouteLeave(to, from, next) {
    // 1. 清除旧暂存：导航目标不是「暂存的目标列表」时清除。
    //    覆盖详情页、分类页等无 keepPageField 页面的离开，避免暂存残留。
    const raw = sessionStorage.getItem(CACHE_KEY);
    if (raw) {
      try {
        const { path } = JSON.parse(raw);
        if (to.path !== path) {
          sessionStorage.removeItem(CACHE_KEY);
        }
      } catch (e) {}
    }

    // 2. 暂存新值：列表页进入详情页时
    if (this.keepPageField && sameDomain(from.path, to.path) && !isInLeftMenu(to.path)) {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({ path: from.path, page: getPath(this, this.keepPageField) }));
    }
    next();
  },
  created() {
    if (!this.keepPageField) return;
    const raw = sessionStorage.getItem(CACHE_KEY);
    if (raw) {
      try {
        const { path, page } = JSON.parse(raw);
        if (path === this.$route.path) {
          setPath(this, this.keepPageField, parseInt(page, 10) || 1);
        }
      } catch (e) {}
      sessionStorage.removeItem(CACHE_KEY);
    }
  }
};
